export default "__VITE_PUBLIC_ASSET__8bd6d0ed__"